"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMediaBadge = exports.isMediaHalon = void 0;

var ui_badge_1 = require("@hopin-team/ui-badge");

var ui_halon_1 = require("@hopin-team/ui-halon");

var react_1 = require("react");

var isMediaHalon = function isMediaHalon(Component) {
  if (!(0, react_1.isValidElement)(Component)) {
    return false;
  }

  return Component.type === ui_halon_1.Halon;
};

exports.isMediaHalon = isMediaHalon;

var isMediaBadge = function isMediaBadge(Component) {
  if (!(0, react_1.isValidElement)(Component)) {
    return false;
  }

  return Component.type === ui_badge_1.Badge;
};

exports.isMediaBadge = isMediaBadge;